/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Public API
 * API that powers FreightSimple\'s SPA
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface User
 */
export interface User {
    /**
     * 
     * @type {string}
     * @memberof User
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    userId: string;
    /**
     * 
     * @type {Date}
     * @memberof User
     */
    lastLoginAt: Date;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    phone: string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    phoneExtension: string;
    /**
     * 
     * @type {boolean}
     * @memberof User
     */
    accountingNotificationsEnabled: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof User
     */
    allShipmentNotificationsEnabled: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof User
     */
    deliveryNotificationsOnlyEnabled: boolean;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    branchName?: string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    branchId?: string;
    /**
     * 
     * @type {boolean}
     * @memberof User
     */
    allowedToSwitchToLinkedCompanies: boolean;
    /**
     * False for a user included here only because they have standing switch access to this company from another company in the same network. Row actions that manage the user (edit, delete, set branch) must be disabled for these rows — the user's real home company is a different one.
     * @type {boolean}
     * @memberof User
     */
    belongsToThisCompany: boolean;
}

/**
 * Check if a given object implements the User interface.
 */
export function instanceOfUser(value: object): value is User {
    if (!('email' in value) || value['email'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('userId' in value) || value['userId'] === undefined) return false;
    if (!('lastLoginAt' in value) || value['lastLoginAt'] === undefined) return false;
    if (!('phone' in value) || value['phone'] === undefined) return false;
    if (!('phoneExtension' in value) || value['phoneExtension'] === undefined) return false;
    if (!('accountingNotificationsEnabled' in value) || value['accountingNotificationsEnabled'] === undefined) return false;
    if (!('allShipmentNotificationsEnabled' in value) || value['allShipmentNotificationsEnabled'] === undefined) return false;
    if (!('deliveryNotificationsOnlyEnabled' in value) || value['deliveryNotificationsOnlyEnabled'] === undefined) return false;
    if (!('allowedToSwitchToLinkedCompanies' in value) || value['allowedToSwitchToLinkedCompanies'] === undefined) return false;
    if (!('belongsToThisCompany' in value) || value['belongsToThisCompany'] === undefined) return false;
    return true;
}

export function UserFromJSON(json: any): User {
    return UserFromJSONTyped(json, false);
}

export function UserFromJSONTyped(json: any, ignoreDiscriminator: boolean): User {
    if (json == null) {
        return json;
    }
    return {
        
        'email': json['email'],
        'name': json['name'],
        'userId': json['userId'],
        'lastLoginAt': (new Date(json['lastLoginAt'])),
        'phone': json['phone'],
        'phoneExtension': json['phoneExtension'],
        'accountingNotificationsEnabled': json['accountingNotificationsEnabled'],
        'allShipmentNotificationsEnabled': json['allShipmentNotificationsEnabled'],
        'deliveryNotificationsOnlyEnabled': json['deliveryNotificationsOnlyEnabled'],
        'branchName': json['branchName'] == null ? undefined : json['branchName'],
        'branchId': json['branchId'] == null ? undefined : json['branchId'],
        'allowedToSwitchToLinkedCompanies': json['allowedToSwitchToLinkedCompanies'],
        'belongsToThisCompany': json['belongsToThisCompany'],
    };
}

  export function UserToJSON(json: any): User {
      return UserToJSONTyped(json, false);
  }

  export function UserToJSONTyped(value?: User | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'email': value['email'],
        'name': value['name'],
        'userId': value['userId'],
        'lastLoginAt': ((value['lastLoginAt']).toISOString()),
        'phone': value['phone'],
        'phoneExtension': value['phoneExtension'],
        'accountingNotificationsEnabled': value['accountingNotificationsEnabled'],
        'allShipmentNotificationsEnabled': value['allShipmentNotificationsEnabled'],
        'deliveryNotificationsOnlyEnabled': value['deliveryNotificationsOnlyEnabled'],
        'branchName': value['branchName'],
        'branchId': value['branchId'],
        'allowedToSwitchToLinkedCompanies': value['allowedToSwitchToLinkedCompanies'],
        'belongsToThisCompany': value['belongsToThisCompany'],
    };
}

